<template>
  <div class="approvalCard" style="margin-top:0;">
    <label style="display:flex; align-items:flex-start; gap:10px; cursor:pointer;">
      <input
        type="checkbox"
        :checked="timezoneAwareSending"
        @change="$emit('update:timezoneAwareSending', ($event.target as HTMLInputElement).checked)"
        style="margin-top:2px; flex-shrink:0;"
      />
      <span>
        <span style="font-weight:700;">Timezone-aware sending</span>
        <div class="hint" style="margin:4px 0 0;">
          When enabled, all reachouts (agent auto-approved and manually approved) are sent during business hours in the contact's timezone. When disabled, reachouts are sent immediately.
        </div>
      </span>
    </label>

    <div v-if="timezoneAwareSending" style="margin-top:14px; padding-left:26px; display:grid; gap:16px;">
      <div class="field" style="margin:0; gap:4px;">
        <label>Default US timezone</label>
        <div class="hint" style="margin:0;">Used for US contacts when their city cannot be resolved to a timezone.</div>
        <select
          class="input"
          :value="defaultUsTimezone"
          @change="$emit('update:defaultUsTimezone', ($event.target as HTMLSelectElement).value)"
        >
          <option value="">— None —</option>
          <option value="America/New_York">Eastern (America/New_York)</option>
          <option value="America/Chicago">Central (America/Chicago)</option>
          <option value="America/Denver">Mountain (America/Denver)</option>
          <option value="America/Los_Angeles">Pacific (America/Los_Angeles)</option>
          <option value="America/Anchorage">Alaska (America/Anchorage)</option>
          <option value="Pacific/Honolulu">Hawaii (Pacific/Honolulu)</option>
        </select>
      </div>

      <div class="field" style="margin:0; gap:4px;">
        <label>Default sending timezone</label>
        <div class="hint" style="margin:0;">Used when no timezone can be inferred from the individual contact (non-US fallback).</div>
        <select
          class="input"
          :value="defaultSendTimezone"
          @change="$emit('update:defaultSendTimezone', ($event.target as HTMLSelectElement).value)"
        >
          <option value="">— None —</option>
          <optgroup label="United States">
            <option value="America/New_York">Eastern (America/New_York)</option>
            <option value="America/Chicago">Central (America/Chicago)</option>
            <option value="America/Denver">Mountain (America/Denver)</option>
            <option value="America/Los_Angeles">Pacific (America/Los_Angeles)</option>
            <option value="America/Anchorage">Alaska (America/Anchorage)</option>
            <option value="Pacific/Honolulu">Hawaii (Pacific/Honolulu)</option>
          </optgroup>
          <optgroup label="Europe">
            <option value="Europe/London">London (Europe/London)</option>
            <option value="Europe/Paris">Paris (Europe/Paris)</option>
            <option value="Europe/Berlin">Berlin (Europe/Berlin)</option>
            <option value="Europe/Amsterdam">Amsterdam (Europe/Amsterdam)</option>
            <option value="Europe/Stockholm">Stockholm (Europe/Stockholm)</option>
          </optgroup>
          <optgroup label="Asia / Pacific">
            <option value="Asia/Dubai">Dubai (Asia/Dubai)</option>
            <option value="Asia/Kolkata">India (Asia/Kolkata)</option>
            <option value="Asia/Singapore">Singapore (Asia/Singapore)</option>
            <option value="Asia/Tokyo">Tokyo (Asia/Tokyo)</option>
            <option value="Australia/Sydney">Sydney (Australia/Sydney)</option>
          </optgroup>
        </select>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  timezoneAwareSending: boolean
  defaultUsTimezone: string
  defaultSendTimezone: string
}>()

defineEmits<{
  'update:timezoneAwareSending': [value: boolean]
  'update:defaultUsTimezone': [value: string]
  'update:defaultSendTimezone': [value: string]
}>()
</script>
